export {
  type CobrandCardHorizontalFlexibleProps,
  type CobrandCardHorizontalFlexibleMBoxProps,
} from './CobrandCardHorizontalFlexible.types';
export { CobrandCardHorizontalFlexible } from './CobrandCardHorizontalFlexible';
